const myMessageView = () => import("~/views/UserCenter/MyMessage/index.vue");
const contractView = () => import("~/views/UserCenter/Contract/index.vue");
const receiverAddressView = () => import("~/views/UserCenter/ReceiverAddress/index.vue");
const messageView = () => import("~/views/UserCenter/Message/index.vue");
const salesmanView = () => import("~/views/UserCenter/SalesMan/index.vue");
const customMessageView = () => import("~/views/UserCenter/CustomMessage/index.vue");
const userView = () => import("~/views/UserCenter/UserView.vue");
const couponView = () => import("./Coupon");
export {
  myMessageView,
  contractView,
  receiverAddressView,
  messageView,
  salesmanView,
  customMessageView,
  userView,
  couponView
};
